import { FC, useMemo, useState } from 'react';
import { HarmReportsTableHeaderProps } from './harmReports.type';
import { Mode } from '../../component/datePickerV2/datePicker.type';
import { UserType } from '@inplay/models';
import { validateAndDecodeAuthToken } from '../../utils/helper';
import { AuthTokenResponse } from '../../service/service.type';
import { Trans } from 'react-i18next';
import Search from '../../component/search/search';
import Button from '../../component/button/button';
import { renderSettingsMenuWithDropdown } from '../userManagement/userManagementHelper';
import Setting from '../../assets/setting.png';
import DatePickerV2 from '../../component/datePickerV2/datePicker';
import {
  getSettingsMenuForHarmReports,
  renderActionButtons,
} from './harmReportesHelper';

export const HarmReportsTableHeader: FC<HarmReportsTableHeaderProps> = (
  props,
) => {
  const [isOpenSettingMenu, setIsOpenSettingMenu] = useState<boolean>(false);

  const userType: UserType | undefined = useMemo(() => {
    const validAuthToken: AuthTokenResponse | null =
      validateAndDecodeAuthToken();
    return validAuthToken?.type as UserType | undefined;
  }, []);

  return (
    <div className="flex items-center justify-between pl-10 pr-8">
      <div className="flex">
        {props.selectedCount > 0 ? (
          renderActionButtons(
            props.selectedCount,
            props.reportLabel ?? '',
            props.handleClose,
            props.handleDelete,
            props.handleDownload,
            props.showDownloadLoading,
          )
        ) : (
          <DatePickerV2
            mode={Mode.Single}
            handleApply={(range) => {
              if (range?.from && props.handleSelectedDate) {
                props.handleSelectedDate(range.from);
              }
            }}
            finalRange={{
              from: props.selectedDate,
              to: undefined,
            }}
            className="top-[165px]"
          />
        )}
      </div>

      <div className="flex">
        {userType !== UserType.VENUE_BRANCH_LOGIN && (
          <Button
            className="ml-2 w-9/12 rounded-full text-sm bg-THEME_COLOR hover:bg-THEME_HOVER_COLOR"
            onClick={props.handleReportHarmClick}
          >
            <Trans i18nKey="harmReports.reportHarm" />
          </Button>
        )}

        <Search
          query={props.searchQuery}
          onChange={props.handleOnChangeSearch}
          placeholder="Search"
          iconSize={13}
          iconRight={false}
          id="custom-search"
          containerClass="w-22 ml-3 mr-3"
          inputClass="text-sm"
        />
        {props.children}
        {renderSettingsMenuWithDropdown(
          Setting,
          isOpenSettingMenu,
          () => setIsOpenSettingMenu((prev) => !prev),
          getSettingsMenuForHarmReports(),
          (label: string | undefined) => props.onSettingMenuSelect?.(label),
          props.disableSettingMenu,
        )}
      </div>
    </div>
  );
};
